import { SelectionPillGroup, SelectionPills } from '@asset-metrix/portal-ui';

import { type DashboardFilterPill } from './dashboardTileFilters';

import styles from './dashboardFilterPills.module.scss';

type DashboardFilterPillsProps = {
  pills: readonly DashboardFilterPill[];
};

export function DashboardFilterPills({ pills }: DashboardFilterPillsProps) {
  if (pills.length === 0) {
    return null;
  }

  return (
    <div className={styles['pills']} data-testid="dashboard-filter-pills">
      {pills.map((pill) => (
        <div className={styles['pill-row']} key={pill.key}>
          <span className={styles['label']}>{pill.label}</span>
          <SelectionPillGroup fullWidth={false}>
            <SelectionPills labels={pill.values} />
          </SelectionPillGroup>
        </div>
      ))}
    </div>
  );
}
